import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isMobileDropdownOpen, setIsMobileDropdownOpen] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const mobileDropdownRef = useRef(null);
  const mobileMenuRef = useRef(null);
  const hamburgerRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;

      if (currentScrollY < lastScrollY) {
        // Scrolling up
        setIsVisible(true);
      } else if (currentScrollY > lastScrollY && currentScrollY > 100) {
        // Scrolling down and past 100px
        setIsVisible(false);
      }

      setLastScrollY(currentScrollY);
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Handle desktop dropdown
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
      // Handle mobile menu (but not mobile dropdown clicks)
      if (
        isMobileMenuOpen &&
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target) &&
        hamburgerRef.current &&
        !hamburgerRef.current.contains(event.target) &&
        mobileDropdownRef.current &&
        !mobileDropdownRef.current.contains(event.target)
      ) {
        setIsMobileMenuOpen(false);
        setIsMobileDropdownOpen(false);
      }
    };

    if (isDropdownOpen || isMobileMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isDropdownOpen, isMobileMenuOpen]);

  // Prevent body scroll when mobile menu is open
  useEffect(() => {
    if (isMobileMenuOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isMobileMenuOpen]);

  const products = [
    { name: 'GFRP Rebar', path: '/product/gfrp-rebar' },
    { name: 'GFRP Mesh', path: '/product/gfrp-mesh' },
    { name: 'Bent Bars & Stirrups', path: '/product/bent-bars-stirrups' }
  ];

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
    setIsMobileDropdownOpen(false);
  };

  const toggleMobileDropdown = (e) => {
    e.stopPropagation();
    setIsMobileDropdownOpen(!isMobileDropdownOpen);
  };

  return (
    <nav className={`navbar ${isVisible ? 'navbar-visible' : 'navbar-hidden'}`}>
      <div className="navbar-container">
        <Link to="/" className="navbar-logo" onClick={closeMobileMenu}>
          <img src="/logo.png" alt="Blitz Fiber Logo" className="navbar-logo-img" />
        </Link>

        {/* Hamburger Button */}
        <button
          ref={hamburgerRef}
          className={`hamburger-menu ${isMobileMenuOpen ? 'hamburger-active' : ''}`}
          onClick={toggleMobileMenu}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Desktop Menu */}
        <ul className="navbar-menu">
          <li><Link to="/" className="navbar-link">HOME</Link></li>
          <li><Link to="/about" className="navbar-link">ABOUT US</Link></li>

          <li
            className="navbar-dropdown-container"
            ref={dropdownRef}
            onMouseEnter={() => setIsDropdownOpen(true)}
            onMouseLeave={() => setIsDropdownOpen(false)}
          >
            <span className="navbar-link navbar-link-dropdown">
              OUR PRODUCTS
            </span>
            {isDropdownOpen && (
              <ul className="navbar-dropdown">
                {products.map((product, index) => (
                  <li key={index}>
                    <Link
                      to={product.path}
                      className="navbar-dropdown-link"
                      onClick={() => setIsDropdownOpen(false)}
                    >
                      {product.name}
                    </Link>
                  </li>
                ))}
              </ul>
            )}
          </li>
          <li><Link to="/team" className="navbar-link">OUR TEAM</Link></li>
          <li><Link to="/blog" className="navbar-link">BLOG</Link></li>
          <li><Link to="/contact" className="navbar-link navbar-link-contact">CONTACT</Link></li>
        </ul>

        {/* Mobile Menu Overlay */}
        {isMobileMenuOpen && (
          <div
            className="mobile-menu-overlay"
            onClick={closeMobileMenu}
          ></div>
        )}

        {/* Mobile Menu */}
        <div
          ref={mobileMenuRef}
          className={`mobile-menu ${isMobileMenuOpen ? 'mobile-menu-open' : ''}`}
        >
          <ul className="mobile-menu-list">
            <li>
              <Link to="/" className="mobile-menu-link" onClick={closeMobileMenu}>
                HOME
              </Link>
            </li>
            <li>
              <Link to="/about" className="mobile-menu-link" onClick={closeMobileMenu}>
                ABOUT US
              </Link>
            </li>
            <li className="mobile-dropdown-container" ref={mobileDropdownRef}>
              <span
                className="mobile-menu-link mobile-menu-link-dropdown"
                onClick={toggleMobileDropdown}
              >
                OUR PRODUCTS
              </span>
              {isMobileDropdownOpen && (
                <ul className="mobile-dropdown">
                  {products.map((product, index) => (
                    <li key={index}>
                      <Link
                        to={product.path}
                        className="mobile-dropdown-link"
                        onClick={closeMobileMenu}
                      >
                        {product.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              )}
            </li>
            <li>
              <Link to="/team" className="mobile-menu-link" onClick={closeMobileMenu}>
                OUR TEAM
              </Link>
            </li>
            <li>
              <Link to="/blog" className="mobile-menu-link" onClick={closeMobileMenu}>
                BLOG
              </Link>
            </li>
            <li>
              <Link to="/contact" className="mobile-menu-link mobile-menu-link-contact" onClick={closeMobileMenu}>
                CONTACT
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;

